import { Pipe, PipeTransform } from '@angular/core';
import { IDashboardHeaderDataItem } from '../../public-api';

@Pipe({
  name: 'cardValue',
})
export class CardValueFormatterPipe implements PipeTransform {
  transform(dataItem: IDashboardHeaderDataItem): string {
    switch (dataItem.valueType) {
      case 'money':
        return (+dataItem.value).toLocaleString(Intl?.NumberFormat().resolvedOptions().locale ?? 'en-IE', { style: 'currency', currency: 'EUR' });
      case 'number':
        return (+dataItem.value).toLocaleString();
      default:
        return dataItem.value;
    }
  }
}
